// Minimal i18n — supports English, Spanish, Chinese, Japanese.
// English is the source of truth; missing keys in other languages fall back to English.
// Categories + business names + admin-supplied copy stay in their original language.

import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

export const LANGS = [
  { code: "en", label: "English",  flag: "🇺🇸" },
  { code: "es", label: "Español",  flag: "🇲🇽" },
  { code: "zh", label: "中文",      flag: "🇨🇳" },
  { code: "ja", label: "日本語",    flag: "🇯🇵" },
];

const STRINGS = {
  en: {
    "nav.businesses": "Business",
    "nav.signin": "Sign in",
    "nav.signout": "Sign out",
    "nav.search": "Search businesses, categories, deals…",
    "hero.tagline": "~ Neon after dark ~",
    "hero.main": "Vegas Unleashed.",
    "hero.sub": "No lines. No filters. Just the Strip at its best.",
    "hero.support": "Every dayclub, residency, secret show & late-night spot — handpicked for people who move different.",
    "hero.swipe": "Swipe",
    "filter.all": "All",
    "filter.adultOnly": "21+ only",
    "signin.title": "Quick sign-in",
    "signin.subtitle": "Business owners and affiliates — no password needed. Just your name and email.",
    "signin.name": "Your name",
    "signin.email": "Email",
    "signin.remember": "Remember me on this device",
    "signin.submit": "Enter Zip City",
    "signin.busy": "Holding the velvet rope…",
    "signin.later": "Maybe later",
    "portal.title": "Business Portal",
    "portal.tab.plans": "Plans",
    "portal.tab.listings": "Listings",
    "portal.tab.ads247": "24/7 Ad",
    "portal.tab.popup": "Pop-up Ads",
    "portal.tab.banner": "Banner",
    "portal.tab.carousel": "Carousel",
    "portal.tab.leads": "Leads",
    "portal.tab.affiliate": "Affiliate",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.close": "Close",
    "common.loading": "Loading…",
    "lang.switch": "Language",
  },
  es: {
    "nav.businesses": "Negocios",
    "nav.signin": "Iniciar sesión",
    "nav.signout": "Cerrar sesión",
    "nav.search": "Buscar negocios, categorías, ofertas…",
    "hero.tagline": "~ Neón después del anochecer ~",
    "hero.main": "Vegas Sin Filtros.",
    "hero.sub": "Sin filas. Sin filtros. Solo el Strip en su mejor momento.",
    "hero.support": "Cada dayclub, residencia, show secreto y lugar de madrugada — seleccionado para quienes se mueven diferente.",
    "hero.swipe": "Deslizar",
    "filter.all": "Todo",
    "filter.adultOnly": "Solo +21",
    "signin.title": "Inicio rápido",
    "signin.subtitle": "Dueños de negocios y afiliados — sin contraseña. Solo tu nombre y correo.",
    "signin.name": "Tu nombre",
    "signin.email": "Correo",
    "signin.remember": "Recordarme en este dispositivo",
    "signin.submit": "Entrar a Zip City",
    "signin.busy": "Sosteniendo la cuerda de terciopelo…",
    "signin.later": "Quizás después",
    "portal.title": "Portal de Negocios",
    "portal.tab.plans": "Planes",
    "portal.tab.listings": "Listados",
    "portal.tab.ads247": "Anuncio 24/7",
    "portal.tab.popup": "Pop-ups",
    "portal.tab.banner": "Banner",
    "portal.tab.carousel": "Carrusel",
    "portal.tab.leads": "Contactos",
    "portal.tab.affiliate": "Afiliado",
    "common.save": "Guardar",
    "common.cancel": "Cancelar",
    "common.delete": "Eliminar",
    "common.edit": "Editar",
    "common.close": "Cerrar",
    "common.loading": "Cargando…",
    "lang.switch": "Idioma",
  },
  zh: {
    "nav.businesses": "商家",
    "nav.signin": "登录",
    "nav.signout": "退出",
    "nav.search": "搜索商家、分类、优惠…",
    "hero.tagline": "~ 霓虹之夜 ~",
    "hero.main": "无拘无束的拉斯维加斯",
    "hero.sub": "无需排队·无需滤镜·拉斯维加斯大道最精华一面",
    "hero.support": "每一家泳池派对、驻场演出、秘密表演、深夜场所——为追求与众不同的人精心挑选",
    "hero.swipe": "滑动",
    "filter.all": "全部",
    "filter.adultOnly": "仅限21岁以上",
    "signin.title": "快速登录",
    "signin.subtitle": "商家和推广员——无需密码,只需姓名和邮箱",
    "signin.name": "您的姓名",
    "signin.email": "邮箱",
    "signin.remember": "在本设备上记住我",
    "signin.submit": "进入 Zip City",
    "signin.busy": "请稍候…",
    "signin.later": "稍后再说",
    "portal.title": "商家门户",
    "portal.tab.plans": "套餐",
    "portal.tab.listings": "店铺",
    "portal.tab.ads247": "24/7 广告",
    "portal.tab.popup": "弹窗广告",
    "portal.tab.banner": "横幅",
    "portal.tab.carousel": "轮播",
    "portal.tab.leads": "客户线索",
    "portal.tab.affiliate": "推广",
    "common.save": "保存",
    "common.cancel": "取消",
    "common.delete": "删除",
    "common.edit": "编辑",
    "common.close": "关闭",
    "common.loading": "加载中…",
    "lang.switch": "语言",
  },
  ja: {
    "nav.businesses": "ビジネス向け",
    "nav.signin": "ログイン",
    "nav.signout": "ログアウト",
    "nav.search": "店舗、カテゴリー、お得情報を検索…",
    "hero.tagline": "〜 夜のネオン 〜",
    "hero.main": "ラスベガス、解き放たれて。",
    "hero.sub": "行列なし、フィルターなし。最高のストリップを。",
    "hero.support": "デイクラブ、レジデンシー、シークレットショー、深夜スポット——感性で動く人のために厳選",
    "hero.swipe": "スワイプ",
    "filter.all": "すべて",
    "filter.adultOnly": "21歳以上のみ",
    "signin.title": "クイックサインイン",
    "signin.subtitle": "ビジネスオーナーとアフィリエイト向け — パスワード不要。名前とメールだけ。",
    "signin.name": "お名前",
    "signin.email": "メールアドレス",
    "signin.remember": "このデバイスで記憶する",
    "signin.submit": "Zip Cityへ入る",
    "signin.busy": "お待ちください…",
    "signin.later": "あとで",
    "portal.title": "ビジネスポータル",
    "portal.tab.plans": "プラン",
    "portal.tab.listings": "リスティング",
    "portal.tab.ads247": "24/7広告",
    "portal.tab.popup": "ポップアップ",
    "portal.tab.banner": "バナー",
    "portal.tab.carousel": "カルーセル",
    "portal.tab.leads": "リード",
    "portal.tab.affiliate": "アフィリエイト",
    "common.save": "保存",
    "common.cancel": "キャンセル",
    "common.delete": "削除",
    "common.edit": "編集",
    "common.close": "閉じる",
    "common.loading": "読み込み中…",
    "lang.switch": "言語",
  },
};

const I18nContext = createContext({ lang: "en", t: (k) => k, setLang: () => {} });

/** Resolve a language code from the visitor's IP-geolocation via our backend.
 *  Falls back to browser `navigator.language` if the geo lookup fails. Never throws. */
async function detectLangFromGeo() {
  // 1. Try our backend (cheap, no third-party deps, respects existing CORS)
  try {
    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
    const r = await fetch(`${BACKEND_URL}/api/geo/lang`, { credentials: "omit" });
    if (r.ok) {
      const j = await r.json();
      if (j && j.lang && ["en", "es", "zh", "ja"].includes(j.lang)) return j.lang;
    }
  } catch (_) { /* network blip, fall through */ }
  // 2. Browser preference fallback
  try {
    const nav = (typeof navigator !== "undefined" && (navigator.language || navigator.userLanguage)) || "";
    const code = nav.toLowerCase().slice(0, 2);
    if (["es", "zh", "ja"].includes(code)) return code;
  } catch (_) { /* noop */ }
  return "en";
}

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try { return localStorage.getItem("zc_lang") || "en"; } catch { return "en"; }
  });

  // First-visit only: ask the backend to geolocate the visitor's IP and auto-pick
  // their preferred language. If the user later changes the language manually,
  // `zc_lang` is set and we never override their choice.
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        if (localStorage.getItem("zc_lang_autodetected")) return;
        if (localStorage.getItem("zc_lang")) return; // they already chose
      } catch { return; }
      const detected = await detectLangFromGeo();
      if (cancelled || !detected || detected === "en") {
        try { localStorage.setItem("zc_lang_autodetected", "1"); } catch {}
        return;
      }
      setLangState(detected);
      try { localStorage.setItem("zc_lang_autodetected", "1"); } catch {}
    })();
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    try { localStorage.setItem("zc_lang", lang); } catch {}
    if (typeof document !== "undefined") document.documentElement.lang = lang;
  }, [lang]);
  const t = useMemo(() => (key) => STRINGS[lang]?.[key] ?? STRINGS.en[key] ?? key, [lang]);
  const value = useMemo(() => ({ lang, setLang: setLangState, t }), [lang, t]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() { return useContext(I18nContext); }

// ── Category translation helpers ──
// Categories returned from /api/categories/full include an optional `i18n` field:
//   { es: {title, tag}, zh: {...}, ja: {...} }
// These helpers return the localized string for the active language with
// safe fallback to English (the c.title / c.tag fields).
export function tCatTitle(c, lang) {
  if (!c) return "";
  if (!lang || lang === "en") return c.title || "";
  return (c.i18n && c.i18n[lang] && c.i18n[lang].title) || c.title || "";
}
export function tCatTag(c, lang) {
  if (!c) return "";
  if (!lang || lang === "en") return c.tag || "";
  return (c.i18n && c.i18n[lang] && c.i18n[lang].tag) || c.tag || "";
}
// Convenience hook — call inside a component to get a (c) => "title" function
// that automatically picks up the current language.
export function useCatT() {
  const { lang } = useI18n();
  return {
    title: (c) => tCatTitle(c, lang),
    tag:   (c) => tCatTag(c, lang),
    lang,
  };
}

// Header dropdown — drop into TopNav
export function LanguageSwitcher({ className = "" }) {
  const { lang, setLang } = useI18n();
  const [open, setOpen] = useState(false);
  const cur = LANGS.find(l => l.code === lang) || LANGS[0];
  return (
    <div className={`relative ${className}`} data-testid="lang-switcher">
      <button onClick={() => setOpen(o => !o)} onBlur={() => setTimeout(() => setOpen(false), 200)}
        className="font-display uppercase text-[10px] tracking-[0.2em] px-2 py-2 whitespace-nowrap text-muted hover:text-gold flex items-center gap-1"
        data-testid="lang-switcher-btn"
        aria-label="Change language">
        <span className="text-sm leading-none">{cur.flag}</span>
        <span className="hidden sm:inline">{cur.code.toUpperCase()}</span>
        <span className="text-[8px]">▼</span>
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-1 bg-surface border border-gold/30 rounded-sm overflow-hidden shadow-2xl z-[200] min-w-[140px]" data-testid="lang-switcher-menu">
          {LANGS.map(l => (
            <button key={l.code} onMouseDown={() => { setLang(l.code); setOpen(false); }}
              data-testid={`lang-option-${l.code}`}
              className={`w-full flex items-center gap-2 px-3 py-2 text-left text-sm hover:bg-gold/10 ${l.code === lang ? "text-gold" : "text-white"}`}>
              <span className="text-base">{l.flag}</span>
              <span>{l.label}</span>
              {l.code === lang && <span className="ml-auto text-gold text-xs">✓</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
